module.exports = "/close-40088b721c61d896c7f6b077fa3bc852.svg";